// extracted by mini-css-extract-plugin
module.exports = {"container":"snackbar-module--container--27AEe","error":"snackbar-module--error--2E2by","content":"snackbar-module--content--OHuiD","close":"snackbar-module--close--yKnxt"};